var collapseData = {
  name: "collapse",
  data: [{
    headerFontColor: "#3889FF",
    headerFontFamily: "PingFangSC-Medium",
    headerFontSize: 14,
    /* 标题左侧竖杠 */
    markerRadius: 1.5,
    markerHeight: 14,
    markerWidth: 3,
    /* 右侧字体 */
    rightTextFont: "PingFangSC-Regular",
    rightTextFontSize: 13
  }]
};
export default collapseData;